import { createFileRoute } from '@tanstack/react-router'

import { DetalheAlerta } from '@/features/meus-alertas/detalhe'

export const Route = createFileRoute('/$perfil/meus-alertas/$alertaId')({
  component: Tela,
})

function Tela() {
  const { perfil, alertaId } = Route.useParams()
  return <DetalheAlerta perfil={perfil} alertaId={alertaId} />
}
